
import { i18nManager } from "../../../i18n";
import * as ReactRouterDom from "react-router-dom";
import Notifications from "../../shared/Notifications";
import { NotificationGroup } from "../../shared/Notifiier";
import { ApiResponseData, BaseService, HostRole, HostService, IHostManager, INotification, ITeamMember, MemberNotificationService, SanitizedResponse, TeamRole, TeamService } from "../../../services";
import { ConfirmDialog, Siren } from "../../shared/ConfirmDialog";
import { AlertInterface, useSubscription } from "@rivtn/noseur";

function HostNotifications() {

    const labels = i18nManager.Labels.host;
    let { id } = ReactRouterDom.useParams();
    const hostService = HostService.getInstance();
    const [searchParams, _] = ReactRouterDom.useSearchParams(window.location.search);

    return (<Notifications
        canGoBack
        service={hostService}
        subTitle={searchParams.get("name") ?? ""}
        title={labels.title + " - " + id + " - " + i18nManager.Labels.compound.top_navbar.popover.notification.notifications}
        markAllAsRead={(done, success) => {
            hostService.markAllNotificationsAsRead(id!).then(({ }: SanitizedResponse<void>) => {
                Siren.alert(i18nManager.Labels.compound.top_navbar.popover.notification.mark_all_read_success);
                success();
            }).catch(BaseService.reportError).finally(done);
        }}
        fetch={(section, done, success) => {
            hostService.queryNotifications({
                "host.public_id": id,
                page: parseInt(searchParams.get("page") ?? "1"),
                size: parseInt(searchParams.get("size") ?? "50"),
                status: (section === "unread" ? "UN_READ" : undefined),
            }).then(({ sanitized, apiResponse }: SanitizedResponse<ApiResponseData<INotification> & { grouped_notifications: NotificationGroup }>) => {
                success(sanitized, apiResponse.secondary_data?.un_reads?.host_notifications);
            }).catch(BaseService.reportError).finally(done);
        }}
    />);

}

export default HostNotifications;
